var map = {
	"./da/slide-1.svg": 20305,
	"./da/slide-2.svg": 49410,
	"./da/slide-3.svg": 28403,
	"./en/slide-1.svg": 15077,
	"./en/slide-2.svg": 95206,
	"./en/slide-3.svg": 41655,
	"./nb/slide-1.svg": 76480,
	"./nb/slide-2.svg": 37491,
	"./nb/slide-3.svg": 33762,
	"./nl/slide-1.svg": 94790,
	"./nl/slide-2.svg": 93925,
	"./nl/slide-3.svg": 39204,
	"./sv/slide-1.svg": 47763,
	"./sv/slide-2.svg": 27008,
	"./sv/slide-3.svg": 62961
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85419;